import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 755.907 755.907"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M747 324H640a140 150 0 0 1 105.766 142.698v114.561A1 1 0 0 1 383 565h48.98V435.54h131.79V324.18H431.98V193.271h-50.07A152 160 0 0 1 747 190zM373.634 8.711v184.573h-51.77V324.18H186.801V8.452h186.832m-52.121 556.414h51.193A1 1 0 0 1 8 581V435.548h313.513z"
    }, null, -1)
  ]))]))
}
export default { render: render }